import { createLoadingReducer } from './utils';

export default createLoadingReducer('STATISTICS');
